import { styled } from "@mui/material/styles"

import Row from "../../../../common/components/Row"

export default styled(Row)(({ theme }) => ({
  flexWrap: "wrap",
  gap: theme.spacing(1),
}))
